import "@mantine/core/styles.css";
import { Container, Flex, useComputedColorScheme } from "@mantine/core";
import { AIChat } from "../AIChat/AIChat";
import { AIChatClientProps } from "../AIChatClient/AIChatClient";

export default function AIChatClientContent(props: AIChatClientProps) {
	const colorScheme = useComputedColorScheme();

	function byColorScheme(object: { light: any; dark: any }) {
		return object[colorScheme];
	}

	return (
		<Container fluid pl="0" pr="0" bg={byColorScheme({ light: "gray.1", dark: "dark.6" })}>
			<Container
				size="sm"
				pl="0"
				pr="0"
				style={{ height: "100dvh" }}
				bg={byColorScheme({ light: "white.0", dark: "dark.7" })}
			>
				<Flex direction="column" style={{ height: "100%" }}>
					<AIChat {...props} byColorScheme={byColorScheme} />
				</Flex>
			</Container>
		</Container>
	);
}
